var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "add-type",
    attrs: {
      title: (_vm.status === "edit" ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("产品大类"),
      visible: _vm.addVisible,
      width: 620
    },
    on: {
      cancel: _vm.closeAddVisible
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品大类"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排序"),
      prop: "sort"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      min: 0
    },
    model: {
      value: _vm.addForm.sort,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "sort", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.sort"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };